//@author: devin

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { S25ToggleButtonModule } from "../../s25-toggle-button/s25.toggle.button.module";
import { S25EditableBooleanComponent } from "./s25.editable.boolean.component";

@NgModule({
    declarations: [S25EditableBooleanComponent],
    imports: [CommonModule, FormsModule, S25ToggleButtonModule],
    exports: [S25EditableBooleanComponent],
    providers: [S25EditableBooleanComponent],
})
export class S25EditableBooleanModule {}
